import { createSelector } from 'reselect';

const getIsFetching = state => state.dashboard.isFetching;
const getUptime = state => state.dashboard.uptime;
const getServicesStatus = state => state.dashboard.servicesStatus;
const getFirewallPolicies = state => state.dashboard.firewallPolicies;
const getFirewallServices = state => state.dashboard.firewallServices;
const getWebSecurityStatus = state => state.dashboard.webSecurityStatus;
const getPartitionsStatus = state => state.dashboard.partitionsStatus;
const getStorageUsage = state => state.dashboard.storageUsage;
const getActiveCalls = state => state.dashboard.activeCalls;
const getFetched = state => state.dashboard.fetched;
const getError = state => state.dashboard.error;
const getUpdates = state => state.dashboard.updates;
const getDevicesUpdates = state => state.dashboard.devicesUpdates;
const getWeakPasswords = state => state.dashboard.weakPasswords;
const getVPNStatus = state => state.dashboard.vpnStatus;
const getCallsSummary = state => state.dashboard.callsSummary;
const getTotalCalls = state => state.dashboard.totalCalls;

export const isFetchingSelector = createSelector(
    getIsFetching,
    isFetching => isFetching
);

export const uptimeSelector = createSelector(
    getUptime,
    uptime => uptime
);

export const servicesStatusSelector = createSelector(
    getServicesStatus,
    servicesStatus => servicesStatus
);

export const firewallPoliciesSelector = createSelector(
    getFirewallPolicies,
    firewallPolicies => firewallPolicies
);

export const firewallServicesSelector = createSelector(
    getFirewallServices,
    firewallServices => firewallServices
);

export const webSecurityStatusSelector = createSelector(
    getWebSecurityStatus,
    webSecurityStatus => webSecurityStatus
);

export const partitionsStatusSelector = createSelector(
    getPartitionsStatus,
    partitionsStatus => partitionsStatus
);

export const storageUsageSelector = createSelector(
    getStorageUsage,
    storageUsage => storageUsage
);

export const activeCallsSelector = createSelector(
    getActiveCalls,
    activeCalls => activeCalls
);

export const fetchedSelector = createSelector(
    getFetched,
    fetched => fetched
);

export const errorSelector = createSelector(
    getError,
    error => error
);

export const updatesSelector = createSelector(
    getUpdates,
    updates => updates
);

export const devicesUpdatesSelector = createSelector(
    getDevicesUpdates,
    devicesUpdates => devicesUpdates
);

export const weakPasswordsSelector = createSelector(
    getWeakPasswords,
    weakPasswords => weakPasswords
);

export const vpnStatusSelector = createSelector(
    getVPNStatus,
    vpnStatus => vpnStatus
);

export const callsSummarySelector = createSelector(
    getCallsSummary,
    callsSummary => callsSummary
);

export const totalCallsSelector = createSelector(
    getTotalCalls,
    totalCalls => totalCalls
);
